import { ConsentAction, PublicBannerConfig } from "./types";

export async function fetchBannerConfig(
  apiBaseUrl: string,
  publicKey: string,
  countryOverride: string | null = null,
): Promise<PublicBannerConfig | null> {
  try {
    const query = countryOverride ? `?country=${countryOverride}` : "";
    const response = await fetch(`${apiBaseUrl}/config/${publicKey}${query}`, {
      credentials: "omit",
    });
    if (!response.ok) {
      const reason =
        response.status === 403
          ? "this domain is not registered for the key"
          : response.status === 404
            ? "unknown key or the banner is not published yet"
            : `HTTP ${response.status}`;
      console.warn(`[BerryCookie] The banner is not shown: ${reason}.`);
      return null;
    }
    return (await response.json()) as PublicBannerConfig;
  } catch {
    console.warn("[BerryCookie] Could not reach the consent service.");
    return null;
  }
}

export interface ConsentPayload {
  visitorId: string;
  bannerVersion: number;
  action: ConsentAction;
  categories: string[];
  language: string;
  pageUrl: string;
  /** The IAB TC string of the decision, when the banner runs the TCF. */
  tcString?: string | null;
}

/** Fire and forget; keepalive lets the request finish when the decision triggers a reload. */
export function sendConsent(
  apiBaseUrl: string,
  publicKey: string,
  payload: ConsentPayload,
  countryOverride: string | null = null,
): void {
  try {
    const query = countryOverride ? `?country=${countryOverride}` : "";
    void fetch(`${apiBaseUrl}/consent/${publicKey}${query}`, {
      method: "POST",
      credentials: "omit",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => undefined);
  } catch {
    // Recording is best effort; the decision is already applied on the page.
  }
}

/** Counts one banner view for the consent rate; carries no visitor data. */
export function sendImpression(apiBaseUrl: string, publicKey: string): void {
  try {
    void fetch(`${apiBaseUrl}/impression/${publicKey}`, {
      method: "POST",
      credentials: "omit",
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Statistics are best effort.
  }
}
